"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupPlan = exports.SignupCurrency = void 0;
let SignupPlan = exports.SignupPlan = /*#__PURE__*/function (SignupPlan) {
  SignupPlan["STARTER"] = "starter";
  SignupPlan["CORE"] = "core";
  SignupPlan["PREMIUM"] = "premium";
  return SignupPlan;
}({});
let SignupCurrency = exports.SignupCurrency = /*#__PURE__*/function (SignupCurrency) {
  SignupCurrency["EUR"] = "eur";
  SignupCurrency["USD"] = "usd";
  return SignupCurrency;
}({});